// extracted by mini-css-extract-plugin
export default {"results-fluid":"Landing_results-fluid__KnDC3"};